var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 24,
    height: 24,
    transform: "translate(-1596 4846)",
    fill: "#da0011",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_40",
    "data-name": "Mask Group 40",
    transform: "translate(1596 -4846)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share-from-square-regular",
    d: "M23.688,5.942l-6-5.629a1,1,0,0,0-1.373,1.453l4.171,3.94H13.677A5.8,5.8,0,0,0,9.208,7.475,6.325,6.325,0,0,0,7.333,12v3.629a.969.969,0,0,0,1,.962.938.938,0,0,0,1-.925V12a4.335,4.335,0,0,1,1.282-3.1,4.037,4.037,0,0,1,3.051-1.229h6.817l-4.171,3.94a1,1,0,0,0-.04,1.413,1.168,1.168,0,0,0,.727.314.992.992,0,0,0,.686-.273l6-5.629A1.145,1.145,0,0,0,24,6.667.993.993,0,0,0,23.688,5.942ZM15,16a.993.993,0,0,0-1,.963v1.962a.3.3,0,0,1-.333.3H2.333a.329.329,0,0,1-.333-.3V7.667a.3.3,0,0,1,.333-.3H4.667a.963.963,0,1,0,0-1.925H2.333A2.328,2.328,0,0,0,0,7.742v11.3a2.328,2.328,0,0,0,2.333,2.3H13.667A2.328,2.328,0,0,0,16,19.038V17.075A1.019,1.019,0,0,0,15,16Z",
    transform: "translate(-1596 4847.314)",
    fill: "#da0011"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.e5a0efcf2a82b3ecf71bc0ddbafdaffe.svg";
export { ForwardRef as ReactComponent };